import React from 'react';
import { siteConfig } from '../data/siteConfig';
export function Footer() {
  const links = siteConfig.legalLinks.filter(l => l.href);
  return <footer className="bg-sand px-5 sm:px-8 py-12 border-t border-ink/10" data-id="element-72" data-mp="3ggk7gsifd7yh">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center justify-between gap-6" data-id="element-73" data-mp="32ovz90bar3ms">
        <p className="font-serif text-xl font-semibold text-teal" data-id="element-74" data-mp="36q93x72nl0s4">{siteConfig.brandName}</p>
        {links.length > 0 && <nav aria-label="Informations légales" data-id="element-75" data-mp="3uftn9r2py01x">
            <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm text-ink/75" data-id="element-76" data-mp="39922nzchmct">
              {links.map(l => <li key={l.label} data-id="element-77" data-mp="3levgx24t5gg6">
                  <a href={l.href} className="hover:text-teal underline-offset-4 hover:underline" data-id="element-78" data-mp="3ldkdx4j6scq4">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>}
        <p className="text-[13px] text-ink/65" data-id="element-79" data-mp="29ydrvn3jig3k">
          © {new Date().getFullYear()} {siteConfig.brandName}
        </p>
      </div>
    </footer>;
}